import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import {
  Datagrid,
  downloadCSV,
  List,
  TextField,
  useGetOne,
  useRecordContext,
  useRefresh,
} from "react-admin"; // eslint-disable-line import/no-unresolved
import useNotify from "../unit/useNotify";

import { CloseOutlined } from "@mui/icons-material";
import PartnersListActions from "../partners/PartnersListActions";
import PartnersListAside from "../partners/PartnersListAside";
import CustomAmountField from "../unit/CustomAmountField";
import PostPagination from "../unit/PostPagination";

import { RaRecord } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import CustomEditIcon from "../unit/CustomEditIcon";
import CustomEditLinkProductIcon from "../unit/CustomEditLinkProductIcon";
import CustomEditRemoveIcon from "../unit/CustomEditRemoveIcon";
import CustomEditTermIcon from "../unit/CustomEditTermIcon";
import CustomLoading from "../unit/CustomLoading";
import CustomUniqueURLIcon from "../unit/CustomUniqueURLIcon";
import VendorsAdd from "./VendorsAdd";
import VendorsEdit from "./VendorsEdit";
import { hmLightTheme } from "../themes/hmTheme";
import SwitchIcon from "../unit/svgIcon/SwitchIcon";
import SwitchOnIcon from "../unit/svgIcon/SwitchOnIcon";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import NoPermission from "../unit/NoPermission";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import getVendorsListFilters from "./VendorsListFilters";
import CustomNoResults from "../unit/CustomNoResults";
const CustomProductNameField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  let productNameArray = record?.sProductName;

  let productNums = 0;
  if (productNameArray) {
    Object.keys(productNameArray).map((key) => {
      productNums++;
    });
  }

  return <Typography>{productNums}</Typography>;
};
const CustomStatusField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  let status = record?.sStatus;
  if (record.sStatus == "1") {
    status = "Active";
  } else if (record.sStatus == "0") {
    status = "Inactive";
  }
  return <Typography>{status}</Typography>;
};
const CustomVendorNameField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  return record?.sName;
};
const VendorTypeExporter = (records: any) => {
  let data = [];
  let title = {};
  data = records.map((record: any) => {
    return {
      id: record.id,
      sName: record.sName,
      sCity: record.sCity,
      sState: record.sState,
      sContactor: record.sContactName,
      productNum: record.productNum,
      sStatus: record.sStatus == "Enabled" ? "Active" : "Inactive",
    };
  });
  title = {
    id: "Ven #",
    sName: "Organization",
    sCity: "City",
    sState: "State",
    sContactor: "Contact Name",
    productNum: "Products Linked",
    sStatus: "Status",
  };
  return {
    title: title,
    data: data,
  };
};

const CustomExporter = (records: any) => {
  const filterData = VendorTypeExporter(records);

  let csvTitle = filterData.title;
  let data = filterData.data;
  const currentFilters = getFiltersFromURL();
  const filterString = Object.entries(currentFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }

      return "";
    })
    .filter(Boolean)
    .join("");
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));

  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }

  downloadCSV(csvDataStr.join("\n"), "Vendors");
};

function getFieldTitle(field: string) {
  const titleMap: Record<string, string> = {
    id: "Ven #",
    sName: "Organization",
    sCity: "City",
    sState: "State",
    sZip: "Zip",
    sContactName: "Contact Name",
    sContactEmail: "Contact Email",
    sContactPhone: "Contact Phone",
    iMaxLoanAmount: "Max Loan Amount",
    iMaxApplicationFee: "Application Fee",
  };

  return titleMap[field] || field;
}

function getFieldValueType(field: string) {
  const typeMap: Record<string, string> = {
    id: "contains",
    sName: "contains",
    sCity: "contains",
    sState: "contains",
    sZip: "contains",
    sContactName: "contains",
    sContactEmail: "contains",
    sContactPhone: "contains",
    iMaxLoanAmount: "is",
    iMaxApplicationFee: "is",
  };

  return typeMap[field] || "is";
}

function getFieldValue(field: string, value: any) {
  if (field == "iMaxLoanAmount" || field == "iMaxApplicationFee") {
    const amountMap: Record<string, string> = {
      "1": "<$1000",
      "2": "$1000-$5000",
      "3": "$5000-$10,000",
      "4": "$10,000-$20,000",
      "5": ">$20,000",
    };

    return amountMap[String(value)] || value;
  }

  return value;
}

interface CustomButtonProps {
  onClick: (record: RaRecord) => void;
  source?: string;
  label?: string;
  sortable?: boolean;
}

const VendorsList = () => {
  const refresh = useRefresh();
  const [editRecord, setEditRecord] = React.useState<RaRecord | null>(null);
  const [open, setOpen] = React.useState(false);
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const [currentTab, setCurrentTab] = React.useState("info");
  const [productList, setProductList] = React.useState([]);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_partners")) {
    return <NoPermission />;
  }
  const { data, isLoading, error } = useGetOne("total/partner", { id: 1 });
  React.useEffect(() => {
    setRecord(data);
  }, [data]);

  const reqUrl = "products/shortList";
  React.useEffect(() => {
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      // console.log("responseData===>", responseData);
      if (responseData) {
        setProductList(responseData);
      }
    };
    fetchData();
  }, []);

  if (error) {
    errorNotify("Error loading data " + error);
  }
  if (isLoading) {
    // return <Typography>Loading ...</Typography>;
    return <HmLoading />;
  }
  const total = record ? record.total : 0;

  const handleClose = () => {
    setOpen(false);
    setEditRecord(null);
    refresh();
  };

  const handleCancel = () => {
    setEditRecord(null);
  };

  const CustomButton = ({ onClick }: CustomButtonProps) => {
    let record = useRecordContext();
    if (!record) return null;
    const refresh = useRefresh();

    const handleClick = (showTab: string) => {
      onClick(record); // 传递当前行数据
      setCurrentTab(showTab);
    };

    const handleRemove = () => {
      var reqUrl = `vendors/actions/delete`;
      sendRequest(reqUrl, { id: record?.id }).then((response) => {
        if (response && response.code == "200") {
          successNotify("Data deleted successfully");
          handleClose();
        } else {
          errorNotify("Data not deleted");
        }
      });
      setOpen(false);
      setEditRecord(null);
    };
    const handleChangeStatus = () => {
      let newStatus = record.sStatus == "Enabled" ? "Disabled" : "Enabled"; // Toggle status

      // Update the record status in the database
      var reqUrl = "vendors/actions/changeStatus";
      var response = sendRequest(reqUrl, {
        id: record.id,
        data: {
          status: newStatus,
        },
      });
      response
        .then((res) => {
          if (res.code == 200) {
            successNotify("Status changed successfully");
            refresh();
          } else {
            errorNotify("Failed to change status! " + res.message);
          }
        })
        .catch((error) => {
          errorNotify("Error changing status: " + error.message);
        });
    };
    const color = "red";
    const size = "22px";
    const fileSrc = "/public/icon/action-delete.svg";

    return (
      <>
        <CustomEditIcon onClick={() => handleClick("info")} label="Edit" />
        <CustomEditLinkProductIcon
          onClick={() => handleClick("linkProducts")}
          label="Link products"
        />
        {/* <CustomEditTermIcon
          onClick={() => handleClick("special")}
          label="Set terms"
        /> */}
        <Tooltip
          title={
            `` + (record?.sStatus == "Enabled" ? "Deactivate" : "Activate") + ``
          }
          placement="left"
        >
          <IconButton
            size="small"
            onClick={handleChangeStatus}
            sx={{ marginLeft: "5px", p: 1 }}
          >
            {record?.sStatus == "Enabled" ? (
              <SwitchOnIcon color="red" />
            ) : (
              <SwitchIcon color="green" />
            )}
          </IconButton>
        </Tooltip>
        {/* <CustomUniqueURLIcon
          onClick={() => handleClick("uniqueURL")}
          label="Unique URL"
        /> */}
        <CustomEditRemoveIcon onClick={() => handleRemove()} />
      </>
    );
  };

  const handleButtonClick = (record: any) => {
    setOpen(true);
    setEditRecord(record);
  };
  const CustomRowStyle = (record: any) => {
    if (!record) return {};

    if (record?.sStatus == "1" || record?.sStatus == "Enabled") {
      return {
        backgroundColor: "#fff",
        "&.MuiTableRow-hover:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      };
    } else {
      return {
        // backgroundColor: "#ffdb9d30",
        // "&.MuiTableRow-hover:hover": {
        //   backgroundColor: "#ffdb9d60",
        // },
        backgroundColor: "#f5f5f5",
        "& td.MuiTableCell-root": {
          color: "gray",
        },
        "& td.MuiTableCell-root span": {
          color: "gray",
        },
        "& td.MuiTableCell-root a": {
          color: "gray",
        },
        "& td.MuiTableCell-root p": {
          color: "gray",
        },
      };
    }
  };
  const authrole = localStorage.getItem("authrole");
  return (
    <>
      <List
        actions={<PartnersListActions selected="vendors" />}
        filters={getVendorsListFilters()}
        aside={<PartnersListAside totalData={total} selected="vendors" />}
        exporter={CustomExporter}
        sort={{ field: "created_at", order: "DESC" }}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={false}
        emptyWhileLoading={false}
        loading={<HmLoading />}
        pagination={<PostPagination />}
        perPage={25}
      >
        <Datagrid
          optimized
          rowClick={false}
          rowSx={CustomRowStyle}
          empty={false}
          // rowClick={handleRowClick}
          size="small"
          id="table-vendors"
          className="hm-list-datagrid"
          sx={{
            ".MuiTableCell-root": {
              // padding:"6px 16px"
              padding: "6px",
            },
            ".RaDatagrid-headerCell:first-child": {
              borderTopLeftRadius: "0px",
            },
            ".RaDatagrid-headerCell:last-child": {
              borderTopRightRadius: "0px",
            },
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" },
            },
            "& .Mui-active": {
              color: "gray",
            },

            "& .MuiTableSortLabel-root": {
              padding: "5px",
            },
            "& .RaDatagrid-headerCell": {
              color: "gray",
              fontSize: "1rem",
              backgroundColor: "#edf4fb",
              wordWrap: "break-word",
            },
            "& .MuiTableCell-paddingCheckbox": {
              display: "none",
            },

            "& .MuiTableCell-root.column-iMaxLoanAmount": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              textAlign: "right",
            },
            "& .MuiTableCell-root.column-iMaxApplicationFee": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
              textAlign: "right",
            },
            "& .MuiTableCell-root.column-sName": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sContactName": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sEmail": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            // sCity ,width:150px
            "& .MuiTableCell-root.column-id": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            },
            "& .MuiTableCell-root.column-sCity": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
            "& .MuiTableCell-root.column-sPhone": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdPhoneWidth,
            },
            "& .MuiTableCell-root.column-sState": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            },
            "& .MuiTableCell-root.column-productNum": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
          }}
        >
          <TextField source="id" label="Ven #" cellClassName="numericText" />
          <CustomVendorNameField source="sName" label="Organization" />
          <TextField source="sCity" label="City" />
          <TextField source="sState" label="State" />

          <TextField source="sContactName" label="Contact Name" />
          {/* <TextField source="sEmail" label="Contact Email" /> */}
          {/* <TextField
            source="sPhone"
            label="Contact Phone"
            cellClassName="numericText"
          /> */}
          <TextField
            source="productNum"
            label="Products Linked"
            cellClassName="numericText"
          />
          {/* <CustomAmountField
            source="iMaxLoanAmount"
            label="Max Loan Amount"
            cellClassName="numericText"
          /> */}
          {/* <CustomAmountField
            source="iMaxApplicationFee"
            label="Application Fee"
            cellClassName="numericText"
          /> */}
          {authrole != "admin" && (
            <CustomButton
              source="column-action"
              label="Action"
              onClick={handleButtonClick}
              sortable={false}
            />
          )}
        </Datagrid>
        <CustomLoading />
      </List>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            let form = document.querySelector(".vendors_edit_dialog_form form");
            let formData = new FormData(form as HTMLFormElement);
            let formJson = Object.fromEntries(formData.entries());

            console.log("vendor formJson===>", formJson);
            if (currentTab == "info") {
              // formJson.sContactName =
              //   formJson.sFirstName + " " + formJson.sLastName;
              //merged first name and last name to contact name
            } else if (currentTab == "linkProducts") {
              let select_products: any[] = [];
              let select = document.querySelectorAll(
                ".vendors_edit_dialog_form .partners_select_product"
              );
              select.forEach((element) => {
                if ((element as HTMLInputElement)?.checked) {
                  select_products.push((element as HTMLInputElement)?.value);
                }
              });
              formJson.productId = select_products.join(",");
            }
            formJson.saveType = currentTab;
            const reqUrl = `vendors/actions/edit`;
            const response = await sendRequest(reqUrl, {
              id: editRecord?.id,
              data: formJson,
            });
            if (response && response.code == "200") {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {/* Vendor Edit Record #{editRecord?.id} */}
          {currentTab == "info" && "Edit info"}
          {currentTab == "linkProducts" && "Link Products"}
          {currentTab == "special" && "Set Terms"}
          {currentTab == "uniqueURL" && "Unique URL"}
          {currentTab == "remove" && "Remove"}
          <IconButton
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              pt: 1,
              height: "50vh",
              maxHeight: "50vh",
            }}
          >
            {editRecord && (
              <VendorsEdit
                id={editRecord.id}
                basePath="/vendors"
                resource="vendors"
                productList={productList}
                curTab={currentTab}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {/* <CustomButtonRemove onClick={handleRemove} /> */}
          <CustomButtonSubmit />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VendorsList;
